import { render, staticRenderFns } from "./landing.vue?vue&type=template&id=2ef2b55e&scoped=true&lang=html"
import script from "./landing.vue?vue&type=script&lang=js"
export * from "./landing.vue?vue&type=script&lang=js"
import style0 from "./landing.vue?vue&type=style&index=0&id=2ef2b55e&prod&lang=css"
import style1 from "./landing.vue?vue&type=style&index=1&id=2ef2b55e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef2b55e",
  null
  
)

export default component.exports